module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-15.cba720ea.png";